import { Box, Typography } from '@mui/material';
import dayjs from 'dayjs';
import Icon from '../../../../Assets/Icon/CustomIcon';
import { useSelector } from 'react-redux';
import { M_PER_CUSTOM_02_Schema } from '../M_PER_CUSTOM_02/M_PER_CUSTOM_02_Schema';

const InfoRow = ({ label, value }) => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'space-between',
      padding: '8px 0',
      gap: 2,
    }}
  >
    <Typography
      sx={{
        fontSize: '14px',
        fontWeight: 500,
        flexShrink: 0,
        minWidth: '120px',
        whiteSpace: 'pre-line',
      }}
    >
      {label}
    </Typography>
    <Typography
      sx={{
        color: '#ff6200ff',
        fontSize: '14px',
        flex: 1,
        textAlign: 'right',
        whiteSpace: 'pre-line',
      }}
    >
      {value || '-'}
    </Typography>
  </Box>
);

export default function BaseInfo(props) {
  const fields = M_PER_CUSTOM_02_Schema.fields.baseInfo;
  const { baseInfo, codeInfo, depApproval } = useSelector(
    (state) => state.permit
  );

  const getSortedFieldsByGroup = (groupName) => {
    return Object.entries(fields)
      .filter(([, meta]) => meta.group === groupName)
      .sort((a, b) => (a[1].order ?? 0) - (b[1].order ?? 0))
      .reduce((result, [key, meta]) => {
        if (key === 'workEndDate') return result;

        let val = baseInfo[key.toUpperCase()] || baseInfo[key];

        if (key === 'workStartDate') {
          const end = baseInfo.WORK_END_DATE || baseInfo.workEndDate;
          val = `${dayjs(val).format('YYYY/MM/DD HH:mm')} ~ ${dayjs(end).format('YYYY/MM/DD HH:mm')}`;
        } else if (meta.type === 'date' && val) {
          val = dayjs(val).format('YYYY/MM/DD');
        } else if (meta.format === 'numeric' && val) {
          val = `${val}명`;
        }

        result.push({
          label: meta.label,
          value: typeof val === 'string' ? val.split(',').join('\n') : val,
        });
        return result;
      }, []);
  };

  const basicInfo = getSortedFieldsByGroup('construction');
  const workOverview = getSortedFieldsByGroup('work');

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <Typography sx={{ fontWeight: 'bold', mb: 1 }}>
          기본 작성 정보
        </Typography>
        {basicInfo.map((item, idx) => (
          <InfoRow key={idx} label={item.label} value={item.value} />
        ))}
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <Typography sx={{ fontWeight: 'bold', mb: 1 }}>작업 개요</Typography>
        {workOverview.map((item, idx) => (
          <InfoRow
            key={idx}
            label={item.label}
            value={item.value}
            isGuardian={item.isGuardian}
          />
        ))}
      </Box>
      {baseInfo.gubun === '요청' && (
        <button
          onClick={() => props.setIsChecked(!props.isChecked)}
          style={{
            display: 'flex',
            gap: 8,
            alignItems: 'center',
            border: 'none',
            backgroundColor: 'transparent',
            cursor: 'pointer',
          }}
        >
          <Icon.CircleCheck
            width={30}
            height={30}
            color={props.isChecked ? '#57B84D' : '#B5B1B1'}
          />
          <Typography
            sx={{
              color: props.isChecked ? '#3A3A3A' : '#B5B1B1',
              fontWeight: props.isChecked ? 'bold' : 'normal',
            }}
          >
            기본 작성 정보를 모두 확인했습니다.
          </Typography>
        </button>
      )}
    </Box>
  );
}
